import React, { useEffect, useState } from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function MetodoAdnCampeonSection() {
  const {
    minutes,
    seconds,
    formatted: formattedTime
  } = useCountdown();
  // Random viewers counter (100-120)
  const [viewers, setViewers] = useState(112);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(Math.floor(Math.random() * (120 - 100 + 1)) + 100);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <section className="w-full text-center" style={{
    padding: '40px 18px 30px 18px',
    background: '#f5f5f5'
  }} data-id="element-86">
      {/* Título */}
      <div style={{
      fontSize: '18px',
      fontWeight: 600,
      color: '#111'
    }} data-id="element-87">
        ⚽ Por eso creamos el{' '}
        <span style={{
        color: '#16a34a',
        fontWeight: 800
      }} data-id="element-88">
          Método ADN CAMPEÓN
        </span>
      </div>

      <p style={{
      marginTop: '12px',
      fontSize: '14px',
      color: '#6b7280',
      fontStyle: 'italic'
    }} data-id="element-89">
        "Porque el talento te lleva hasta cierto punto… pero la mentalidad lo
        cambia todo."
      </p>

      {/* Imagen Producto */}
      <div style={{
      marginTop: '25px'
    }} data-id="element-90">
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771287449/2_m2bqoa.png" alt="Método ADN Campeón - Producto digital" style={{
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        maxWidth: '320px',
        borderRadius: '12px',
        boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
      }} data-id="element-91" />
      </div>

      <div style={{
      marginTop: '12px',
      fontSize: '13px',
      color: '#9ca3af',
      fontWeight: 600
    }} data-id="element-92">
        +5.200 DESCARGAS
      </div>

      <div style={{
      marginTop: '14px',
      fontSize: '16px',
      fontWeight: 700,
      color: '#111'
    }} data-id="element-93">
        ⚽ Método ADN CAMPEÓN + 5 Regalos Exclusivos 🎁
      </div>

      {/* Tarjeta Precio */}
      <div style={{
      marginTop: '20px',
      background: 'linear-gradient(180deg, #0b0f19, #111827)',
      padding: '22px',
      borderRadius: '16px',
      border: '1px solid #16a34a',
      boxShadow: '0 0 25px rgba(22,163,74,0.3)',
      color: '#fff'
    }} data-id="element-94">
        <div style={{
        textDecoration: 'line-through',
        color: '#9ca3af',
        fontSize: '14px'
      }} data-id="element-95">
          $67.999 ARS
        </div>

        <div style={{
        fontSize: '34px',
        fontWeight: 800,
        color: '#22c55e',
        marginTop: '6px'
      }} data-id="element-96">
          $17.999 ARS
        </div>

        <div style={{
        marginTop: '8px',
        background: '#16a34a',
        color: '#000',
        fontWeight: 700,
        padding: '6px 12px',
        borderRadius: '20px',
        display: 'inline-block',
        fontSize: '13px'
      }} data-id="element-97">
          AHORRÁ $50.000
        </div>

        <div style={{
        marginTop: '16px',
        borderTop: '1px solid rgba(255,255,255,0.2)',
        paddingTop: '12px',
        fontSize: '13px',
        color: '#d1d5db'
      }} data-id="element-98">
          Compra Segura &nbsp;&nbsp;|&nbsp;&nbsp; Acceso Instantáneo
        </div>
      </div>

      {/* Tarjeta Oferta */}
      <div style={{
      marginTop: '18px',
      background: 'linear-gradient(180deg, #1f2937, #111827)',
      padding: '22px',
      borderRadius: '16px',
      border: '1px solid #22c55e',
      color: '#fff',
      boxShadow: '0 0 20px rgba(34,197,94,0.25)'
    }} data-id="element-99">
        <div style={{
        color: '#22c55e',
        fontWeight: 800,
        fontSize: '16px'
      }} data-id="element-100">
          ¡OFERTA SOLO POR HOY!
        </div>

        <p style={{
        marginTop: '10px',
        fontSize: '13px',
        color: '#d1d5db',
        lineHeight: 1.5
      }} data-id="element-101">
          Tu lugar con los 5 BONOS de REGALO solo está reservado por los
          próximos minutos. ¡No pierdas tus beneficios!
        </p>

        <div style={{
        marginTop: '10px',
        fontSize: '13px',
        color: '#9ca3af'
      }} data-id="element-102">
          La oferta se termina en:
        </div>

        <div aria-live="polite" aria-label={`Tiempo restante: ${minutes} minutos y ${seconds} segundos`} style={{
        marginTop: '6px',
        fontSize: '20px',
        fontWeight: 800,
        color: '#22c55e'
      }} data-id="element-103">
          {formattedTime}
        </div>

        <button style={{
        marginTop: '14px',
        width: '100%',
        background: '#22c55e',
        color: '#000',
        fontWeight: 800,
        padding: '14px',
        border: 'none',
        borderRadius: '30px',
        fontSize: '14px',
        cursor: 'pointer'
      }} aria-label="Ahorrá $50.000 ahora - Acceder a la oferta" data-id="element-104">
          ¡AHORRÁ $50.000 AHORA!
        </button>
      </div>

      {/* Personas viendo */}
      <div aria-live="polite" style={{
      marginTop: '14px',
      background: '#111827',
      color: '#fff',
      padding: '12px',
      borderRadius: '12px',
      fontSize: '13px',
      fontWeight: 600
    }} data-id="element-105">
        {viewers} personas están viendo esta oferta
      </div>

      {/* Cupos */}
      <div style={{
      marginTop: '10px',
      background: '#dc2626',
      color: '#fff',
      padding: '12px',
      borderRadius: '12px',
      fontSize: '13px',
      fontWeight: 700
    }} data-id="element-106">
        🔴 Últimos 5 Cupos en Oferta
      </div>

      {/* Botón Principal */}
      <a href="https://infoliar.com/cart/56736084721996:1" className="adn-pulse-btn" style={{
      marginTop: '16px',
      width: '100%',
      display: 'block',
      background: 'linear-gradient(90deg, #16a34a, #22c55e)',
      color: '#fff',
      fontWeight: 800,
      padding: '16px',
      border: 'none',
      borderRadius: '40px',
      fontSize: '15px',
      cursor: 'pointer',
      textDecoration: 'none',
      textAlign: 'center',
      boxSizing: 'border-box'
    }} aria-label="Accedé al Método ADN Campeón" data-id="element-107">
        ACCEDÉ AL MÉTODO YA MISMO
      </a>

      {/* Garantía */}
      <div style={{
      marginTop: '20px',
      background: '#fff',
      padding: '18px',
      borderRadius: '14px',
      boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
    }} data-id="element-108">
        <div style={{
        fontWeight: 700,
        color: '#16a34a',
        fontSize: '14px'
      }} data-id="element-109">
          Garantía de Satisfacción
        </div>

        <div style={{
        fontSize: '13px',
        color: '#6b7280',
        marginTop: '4px'
      }} data-id="element-110">
          30 días para probar sin riesgo alguno
        </div>

        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771287819/image_41_ktiee7.jpg" alt="Garantía de satisfacción - 30 días" style={{
        width: '100%',
        marginTop: '12px',
        borderRadius: '8px'
      }} data-id="element-111" />
      </div>
    </section>;
}